export const BUCKZY_CONSTANTS = {
    COUNTRY_CODES: {
        CANADA: "ca",
        INDIA: "IN"
    },
    DIAL_CODES: {
        CANADA: "1"
    },
    CODE_TYPES: {
        DOCUMENT_TYPE: 'DOCUMENT_TYPE',
        LINE_OF_BUSINESS: 'LINE_OF_BUSINESS',
        SOURCE_OF_WEALTH: 'SOURCE_OF_WEALTH',
        CORPORATION_TYPE: 'CORPORATION_TYPE',
        ORGANIZATION_TYPE: 'ORGANIZATION_TYPE',
        OCCUPATION: 'OCCUPATION',
        RELATIONSHIP: 'RELATIONSHIP'
    },
    PAGES: {
        PARTY_DETAILS: 'PARTY_DETAILS',
        BENEFICIAL_OWNER_DETAILS: 'BENEFICIAL_OWNER_DETAILS'
    },
    PARTY: {
        PARTY_SIDE: {
            DEBTOR: "Debtor",
            CREDITOR: "Creditor",
            BENEFICIARY: "Beneficiary",
            SENDER: "Sender",
            RECEIVER: "Receiver"
        },
        PARTY_TYPE: {
            BUSINESS: {
                DESCRIPTION: 'Business',
                CODE: 'B'
            },
            INDIVIDUAL: {
                DESCRIPTION: 'Individual',
                CODE: 'I'
            }
        },
        ACTION: {
            UPDATE: 'Update',
            ADD: 'Add'
        },
    },
    URL: {
        RECEIVERS: '/pages/profile-management/receivers',
        SENDERS: '/pages/profile-management/senders',
        DASHBOARD: '/pages/payout-dashboard'
    },
    SORT: {
        ASCENDING: 'ASC',
        DESCENDING: 'DESC'
    },
    DATE_FORMAT: {
        ISO_DATE: 'yyyy-MM-dd'
    },
    LOCALE: {
        EN_CA: 'en-CA'
    },
    EMAIL_REGEXP: /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
}

export declare type CODE_TYPE = 'DOCUMENT_TYPE' | 'LINE_OF_BUSINESS' | 'SOURCE_OF_WEALTH' | 'ORGANIZATION_TYPE' | 'CORPORATION_TYPE' | 'OCCUPATION' |'RELATIONSHIP';

/**
 * This is an update version of https://github.com/angular/angular/blob/19.0.6/packages/forms/src/validators.ts#L139-L140
 * This regex enforces the following rules for a valid email address:
 *
 * The total length must be between 1 and 254 characters.
 * The local part (before the @ symbol) must be between 1 and 64 characters.
 * The local part can contain alphanumeric characters and special characters like !#$%&'+/=?^_{|}~-`.
 * The domain part must have valid domain labels, each between 1 and 63 characters, separated by dots.
 * The domain part must end with a valid domain label.
 * This regex ensures that the email address adheres to the general rules and constraints specified in RFC 5321 and RFC 5322.
 */
export const EMAIL_REGEX_ADV = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
